import { t } from '@lingui/macro';

export default ({ i18n }) => ({
  CURRICULUM_TEXT: i18n.t`Curriculum`,
  COURSE_TEXT: i18n.t`Grade/Course`,
  PDF_TEXT: i18n._(t('CourseFilters.pdf')`Curriculum Alignment PDF available`)
});



// WEBPACK FOOTER //
// ./components/course-filters/translations.js